export default "__VITE_ASSET__O26BrT22__"